import { z } from 'zod';

import { env } from '../../env';

import { parseTokenInfo } from './parseTokenInfo';

const pidAccessTokenInfoSchema = z.object({
	exp: z.number(),
	resource_access: z.object({
		'world-idm-boa': z.object({
			roles: z.array(z.string()),
		}),
	}),
	name: z.string().optional(),
	email: z.string().optional(),
	user_attributes: z.object({
		pidUuid: z.string(),
	}),
});

export const pfsAccessTokenInfoSchema = z.object({
	exp: z.number(),
	resource_access: z.object({
		'world-pfs': z.object({
			roles: z.array(z.string()),
		}),
	}),
	user_attributes: z.object({
		userId: z.string(),
	}),
});

export type AccessTokenInfo = {
	exp: number;
	roles: string[];
	name?: string;
	email?: string;
	pidUuid?: string;
	userId?: string;
};

export const getAccessTokenInfo = (
	token: string,
): AccessTokenInfo | undefined => {
	if (env.CLIENT_RUNS_IN === 'BANK') {
		const parsedToken = parseTokenInfo(token, pidAccessTokenInfoSchema);

		if (!parsedToken) return undefined;

		const accessTokenInfo: AccessTokenInfo = {
			exp: parsedToken.exp,
			roles: parsedToken.resource_access['world-idm-boa'].roles,
			name: parsedToken.name,
			email: parsedToken.email,
			pidUuid: parsedToken.user_attributes.pidUuid,
		};
		return accessTokenInfo;
	} else {
		const parsedToken = parseTokenInfo(token, pfsAccessTokenInfoSchema);

		if (!parsedToken) return undefined;

		const accessTokenInfo: AccessTokenInfo = {
			exp: parsedToken.exp,
			roles: parsedToken.resource_access['world-pfs'].roles,
			userId: parsedToken.user_attributes.userId,
		};
		return accessTokenInfo;
	}
};
